import React, { Fragment, createElement } from 'react';
import { motion } from 'framer-motion';
import { ShoppingCart, PackageCheck, Home, XCircleIcon, RotateCcwIcon } from 'lucide-react';
import type { DashboardMetrics } from '../utils/calculations';
interface DeliveryFunnelProps {
  metrics: DashboardMetrics;
}
export function DeliveryFunnel({
  metrics
}: DeliveryFunnelProps) {
  const funnelSteps = [{
    label: 'Pedidos',
    value: metrics.funnelOrders,
    percentage: '100%',
    icon: ShoppingCart,
    color: 'bg-cyber-green'
  }, {
    label: 'Despachados',
    value: metrics.funnelDispatched,
    percentage: `${metrics.dispatchedPct}%`,
    icon: PackageCheck,
    color: 'bg-white'
  }, {
    label: 'Entregados',
    value: metrics.funnelDelivered,
    percentage: `${metrics.efectividadReal.toFixed(1)}%`,
    icon: Home,
    color: 'bg-salmon'
  }];
  const dropOffs = [{
    label: 'Cancelados',
    pct: metrics.cancelledPct,
    icon: XCircleIcon,
    color: 'text-yellow-400'
  }, {
    label: 'Devueltos',
    pct: metrics.returnedPct,
    icon: RotateCcwIcon,
    color: 'text-danger-red'
  }];
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.5,
    delay: 0.4
  }} className="glass-card p-6 md:p-8" data-id="element-91">
      <h2 className="text-sm font-bold tracking-widest text-white/70 uppercase mb-6 text-center" data-id="element-92">
        Embudo COD
      </h2>

      <div className="flex flex-col md:flex-row items-center justify-between gap-3 md:gap-0 relative" data-id="element-93">
        <div className="hidden md:block absolute top-1/2 left-[8%] right-[8%] h-0.5 bg-white/10 -translate-y-1/2 z-0" data-id="element-94"></div>

        {funnelSteps.map((step, index) => <Fragment key={index} data-id="element-95">
            <motion.div initial={{
          scale: 0.8,
          opacity: 0
        }} animate={{
          scale: 1,
          opacity: 1
        }} transition={{
          delay: 0.5 + index * 0.15,
          type: 'spring'
        }} className="relative z-10 flex flex-col items-center w-full md:w-1/4" data-id="element-96">
              <div className="w-16 h-16 md:w-20 md:h-20 rounded-full flex items-center justify-center bg-black border-2 border-white/10 shadow-lg relative group" data-id="element-97">
                <div className={`absolute inset-0 rounded-full opacity-20 blur-xl ${step.color} group-hover:opacity-40 transition-opacity`} data-id="element-98"></div>
                <span className="block text-xl md:text-2xl font-black text-white relative z-10" data-id="element-99">
                  {step.value}
                </span>
                <div className="absolute -top-1.5 -right-1.5 w-6 h-6 rounded-full bg-black border border-white/20 flex items-center justify-center" data-id="element-100">
                  {createElement(step.icon, {
                className: 'w-3 h-3 text-white/70'
              })}
                </div>
              </div>
              <div className="mt-3 text-center" data-id="element-101">
                <h3 className="text-xs font-bold text-white uppercase tracking-wider" data-id="element-102">
                  {step.label}
                </h3>
                <span className={`inline-block mt-1 px-2 py-0.5 rounded text-[10px] font-bold text-black ${step.color}`} data-id="element-103">
                  {step.percentage}
                </span>
              </div>
            </motion.div>

            {index < dropOffs.length && <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          delay: 0.7 + index * 0.15
        }} className="relative z-10 flex flex-col items-center px-1 md:w-auto" data-id="element-104">
                <div className={`flex items-center gap-1 px-2 py-1 rounded-lg bg-black/60 border border-white/5 ${dropOffs[index].color}`} data-id="element-105">
                  {createElement(dropOffs[index].icon, {
              className: 'w-3 h-3'
            })}
                  <span className="text-[10px] font-bold" data-id="element-106">
                    -{dropOffs[index].pct}%
                  </span>
                </div>
                <span className="text-[9px] text-white/30 mt-0.5 font-medium" data-id="element-107">
                  {dropOffs[index].label}
                </span>
              </motion.div>}
          </Fragment>)}
      </div>

      <div className="mt-6 pt-4 border-t border-white/5" data-id="element-108">
        <div className="flex items-center justify-between text-xs" data-id="element-109">
          <span className="text-white/30 font-medium" data-id="element-110">De cada 100 pedidos</span>
          <span className="font-bold" data-id="element-111">
            <span className="text-danger-red" data-id="element-112">
              {metrics.cancelledPct} cancelados
            </span>
            <span className="text-white/20 mx-2" data-id="element-113">→</span>
            <span className="text-yellow-400" data-id="element-114">
              {metrics.funnelDispatched - metrics.funnelDelivered} devueltos
            </span>
            <span className="text-white/20 mx-2" data-id="element-115">→</span>
            <span className="text-cyber-green" data-id="element-116">
              {metrics.funnelDelivered} entregados
            </span>
          </span>
        </div>
      </div>
    </motion.div>;
}